module.exports = __webpack_public_path__ + "static/media/you-are-here.9ccb6ff4.svg";